import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation  } from "react-router-dom";

export default function Navbar(props) {
    const location = useLocation();
    const pathName = location.pathname;

    return (
        <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">{props.title}</Link >
                {/* <a className="navbar-brand" href="#">{props.title}</a> */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                        <Link className={`nav-link ${pathName==='/'?'active':''}`} to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathName==='/about'?'active':''}`} to="/about">{props.aboutText}</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${pathName==='/password-generator'?'active':''}`} to="/password-generator">Password Generator</Link>
                        </li>
                    </ul>
                    
                    {/* <ul className='navbar-nav me-3'>
                        <li><button className='btn btn-primary mx-1' onClick={()=>{props.changeBackground('primary')}} style={{width:'10px', height:'25px'}}></button></li>
                        <li><button className='btn btn-secondary mx-1' onClick={()=>{props.changeBackground('secondary')}} style={{width:'10px', height:'25px'}}></button></li>
                        <li><button className='btn btn-success mx-1' onClick={()=>{props.changeBackground('success')}} style={{width:'10px', height:'25px'}}></button></li>
                        <li><button className='btn btn-danger mx-1' onClick={()=>{props.changeBackground('danger')}} style={{width:'10px', height:'25px'}}></button></li>
                        <li><button className='btn btn-warning mx-1' onClick={()=>{props.changeBackground('warning')}} style={{width:'10px', height:'25px'}}></button></li>
                        <li><button className='btn btn-info mx-1' onClick={()=>{props.changeBackground('info')}} style={{width:'10px', height:'25px'}}></button></li>
                    </ul> */}
                    {/* <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
                        <input className="form-check-input" type="checkbox" role="switch" onClick={props.toggleMode} />
                        <label className="form-check-label">Enable {props.mode==='light'?'Dark':'Light'} Mode</label>
                    </div> */}
                </div>
            </div>
        </nav>
    )
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    aboutText: PropTypes.string.isRequired
}

Navbar.defaultProps = {
    title: 'Set title here',
    aboutText: 'About'
  };